// Selects the whole application at build time. The mode is configuration,
// never a user-facing toggle: set REACT_APP_UI_MODE=modern to build the
// Sakura-Modern experience; anything else builds the legacy application.
export const UI_MODES = Object.freeze({ LEGACY: 'legacy', MODERN: 'modern' });

export const resolveUiMode = (value) => (
  String(value || '').trim().toLowerCase() === UI_MODES.MODERN ? UI_MODES.MODERN : UI_MODES.LEGACY
);

export const UI_MODE = resolveUiMode(process.env.REACT_APP_UI_MODE);

export const isModernUi = UI_MODE === UI_MODES.MODERN;
